import { useParams, Link } from "react-router-dom";
import { useLanguage } from "../i18n/LanguageContext";
import { articles } from "../data/articles";
import { Reveal } from "../components/Reveal";
import { ArrowLeft, ArrowRight, Clock } from "lucide-react";

const BlogArticle = () => {
  const { slug } = useParams();
  const { t, lang } = useLanguage();
  const article = articles.find((a) => a.slug === slug);
  const BackArrow = lang === "ar" ? ArrowRight : ArrowLeft;

  if (!article) {
    return (
      <main className="mx-auto max-w-3xl px-6 pb-24 pt-44 text-center">
        <p className="text-zinc-500" data-testid="article-not-found">404</p>
        <Link to="/blog" className="text-gold">{t.blog.back}</Link>
      </main>
    );
  }

  const renderBlock = (block, i) => {
    if (block.startsWith("## ")) {
      return <h2 key={i} className="mt-12 font-display text-2xl font-bold md:text-3xl">{block.slice(3)}</h2>;
    }
    if (block.startsWith("- ")) {
      return (
        <div key={i} className="mt-3 flex items-start gap-3 text-zinc-400">
          <span className="mt-2 h-1.5 w-1.5 shrink-0 rounded-full bg-gold" />
          <p className="text-base leading-relaxed md:text-lg">{block.slice(2)}</p>
        </div>
      );
    }
    return <p key={i} className="mt-6 text-base leading-relaxed text-zinc-400 md:text-lg">{block}</p>;
  };

  return (
    <main data-testid="blog-article-page" className="mx-auto max-w-3xl px-6 pb-24 pt-36 lg:pt-44">
      <Reveal>
        <Link to="/blog" data-testid="article-back" className="inline-flex items-center gap-2 text-xs font-bold uppercase tracking-widest text-zinc-500 transition-colors hover:text-gold">
          <BackArrow size={14} /> {t.blog.back}
        </Link>
        <h1 className="mt-8 font-display text-3xl font-extrabold leading-tight md:text-5xl">{article.title[lang]}</h1>
        <div className="mt-6 flex items-center gap-3 text-xs text-zinc-600">
          <span>{article.date}</span>
          <span className="h-1 w-1 rounded-full bg-gold/50" />
          <span className="flex items-center gap-1"><Clock size={12} /> {article.readTime} {t.blog.minRead}</span>
        </div>
        <div className="mt-10 border-t border-white/10 pt-4" data-testid="article-body">
          {article.body[lang].map(renderBlock)}
        </div>
      </Reveal>
    </main>
  );
};

export default BlogArticle;
